export const filterTypesOptions = [{ label: 'Group', value: 'group' }];
